import React from 'react';
import { Snackbar, Alert } from '@mui/material';

interface NotificationSnackbarProps {
  message: string;
  severity: 'success' | 'error';
  open?: boolean;
  autoHideDuration?: number;
  onClose: () => void;
}

function NotificationSnackbar({
  message,
  severity,
  open = true,
  autoHideDuration = 3000,
  onClose
}: NotificationSnackbarProps): React.ReactElement {
  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
    >
      <Alert severity={severity} variant='filled' onClose={onClose}>
        {message}
      </Alert>
    </Snackbar>
  );
}

export default NotificationSnackbar;
